// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"Tags_tagContainer__TnPWr","marginBottom":"Tags_marginBottom__H2fZ_","tag":"Tags_tag__KB2o5","verticalSeparator":"Tags_verticalSeparator__omrm_"};